import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect } from 'react'
import { chatBotSelectors, chatBotThunks } from '@ucheba/store/chat-bot'
import { EMessengerType } from '@ucheba/store/profile/types'
import { UCHEBA_SITE_NAME } from '../constants/core'
import { getVisitInfo } from './useVisitsTracker'

interface IPayload {
  [key: string]: any
}

interface IUseRedirectToMessenger {
  (
    scenario: string,
    messengerType: keyof typeof EMessengerType,
    channelId?: number,
    payload?: IPayload,
    templateId?: string | number,
    siteName?: string
  ): void
}

/** Хук для запуска сценария и редиректа в мессенджер */
export const useRedirectToMessenger: IUseRedirectToMessenger = (
  scenario,
  messengerType,
  channelId,
  templateId,
  siteName,
  payload = {}
) => {
  const dispatch = useDispatch()
  const redirectUrl = useSelector(chatBotSelectors.redirectUrl)

  const redirectToMessenger = useCallback(
    async (userTags) => {
      if (!redirectUrl) {
        const data = {
          messengerType,
          channelId,
          userTags: { ...userTags },
          payload,
          visit: getVisitInfo(siteName || UCHEBA_SITE_NAME),
        }

        if (templateId) {
          data.templateId = templateId
        } else {
          data.scenario = scenario
        }

        await dispatch(
          chatBotThunks.start({
            data,
          })
        )
      }

      if (redirectUrl) {
        window.location.href = redirectUrl
      }
    },
    [redirectUrl, messengerType, payload, siteName, templateId, dispatch, scenario]
  )

  useEffect(() => {
    const userTags = {
      ...JSON.parse(localStorage.getItem('userTags') || '{}'),
    }

    redirectToMessenger(userTags)
  }, [redirectUrl])
}
